export const APP_TYPE_APP_LAUNCH = 'app_launch';
export const APP_TYPE_CUSTOM = 'custom';
export const APP_TYPE_DATA_FORWARD = 'data_forward';
export const APP_TYPE_DATA_SHARE = 'data_share';
export const APP_LAUNCHER_AVIVE = 'avive';
export const APP_LAUNCHER_AGENT_511 = 'agent_511';
export const APP_LAUNCHER_EAGLEVIEW = 'eagleview';
export const APP_LAUNCHER_UNITE = 'unite_app_launcher';
